// 20250707: xt grk handle payload.details here and keep redirectToReferrer
import { SET_PROFILE, AUTH_CALLED } from '../actions/profile';

const initialState = {
  // details: {}, // we are removing the detail entry again!!
  redirectToReferrer: false,
  authCalled: false,
  error: null,
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROFILE:
      return {
        ...state,
      // set profile data directly as properties
        ...action.payload,  // spread profile fields directly into state
        error: action.payload.error || null,
        redirectToReferrer: state.authCalled || false,
        authCalled: false
      };
    case AUTH_CALLED:
      return { ...state, authCalled: true };
    default:
      return state;
  }
};

export default profile;